var toggle = {
    init: function() {
        $(document).on('click', '[data-toggle]', function(e) {
            e.preventDefault();
            $(this).toggleClass('open').next('.toggle-target').slideToggle();
        });
    }
};
